<template>
  <section class="contactButton">
    <div class="container">
      <div class="rowView">
  <router-link to="/customer/contact" class="pageLinkButton"><span>お問い合わせフォーム</span></router-link>
      </div>
    </div>
  </section>
</template>

<script>
/*
汎用性を持たせようと思ったが、場所によってはa hrefでなくrouter-link toが必要となるなど箇所箇所でいい気がする。
やはり同じクラスを振っておくだけで箇所箇所でカスタマイズする
*/
export default {
  name: 'contactButton',
}
</script>

<style>
</style>
